import React from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
    return (
        <div className="terms-page">
            {/* Hero Section */}
            <section className="terms-hero">
                <div className="hero-pattern"></div>
                <div className="hero-content">
                    <h1>
                        <span className="hero-title">Terms & Conditions</span>
                    </h1>
                    <p className="hero-description">
                        Please read these terms carefully before booking your journey with us
                    </p>
                    <div className="last-updated">
                        <i className="fas fa-calendar-alt"></i>
                        <span>Last updated: March 2026</span>
                    </div>
                </div>
              
            </section>

            {/* Main Content */}
            <div className="terms-container">
                <div className="terms-grid">
                    {/* Sidebar Navigation */}
                    <aside className="terms-sidebar">
                        <div className="sidebar-sticky">
                            <h3>Quick Navigation</h3>
                            <ul className="sidebar-nav">
                                <li><a href="#booking">1. Booking & Payment</a></li>
                                <li><a href="#cancellation">2. Cancellation Policy</a></li>
                                <li><a href="#insurance">3. Travel Insurance</a></li>
                                <li><a href="#itinerary">4. Changes to Itinerary</a></li>
                                <li><a href="#liability">5. Liability</a></li>
                                <li><a href="#privacy">6. Privacy Policy</a></li>
                                <li><a href="#conduct">7. Guest Conduct</a></li>
                                <li><a href="#force">8. Force Majeure</a></li>
                            </ul>
                            <div className="sidebar-contact">
                                <p>Have questions?</p>
                                <a href="tel:+919335444047" className="contact-phone">
                                    <i className="fas fa-phone-alt"></i> +91 9335444047
                                </a>
                                <a href="mailto:legal@redgotrips.com" className="contact-email">
                                    <i className="fas fa-envelope"></i> legal@redgotrips.com
                                </a>
                            </div>
                        </div>
                    </aside>

                    {/* Main Content Area */}
                    <main className="terms-main">
                        <div className="terms-content">
                            {/* Introduction */}
                            <div className="terms-intro">
                                <p className="intro-text">
                                    Welcome to Redgotrip. By accessing or using our services, you agree to be bound by these Terms and Conditions. Please read them carefully before making any booking with us.
                                </p>
                            </div>

                            {/* Section 1 */}
                            <section id="booking" className="terms-section">
                                <div className="section-badge">01</div>
                                <h2>Booking and Payment</h2>
                                <div className="section-content">
                                    <p>All bookings are subject to availability. Payment must be made in full at the time of booking unless otherwise agreed. We accept the following payment methods:</p>
                                    <ul className="payment-methods-list">
                                        <li><i className="fab fa-cc-visa"></i> Visa Credit/Debit Cards</li>
                                        <li><i className="fab fa-cc-mastercard"></i> Mastercard</li>
                                        <li><i className="fab fa-cc-amex"></i> American Express</li>
                                        <li><i className="fas fa-university"></i> Bank Transfer (NEFT/IMPS)</li>
                                        <li><i className="fab fa-google-pay"></i> UPI (Google Pay, PhonePe, Paytm)</li>
                                    </ul>
                                    <div className="note-box">
                                        <i className="fas fa-info-circle"></i>
                                        <p>A booking confirmation will be sent to your email address once payment is successfully processed.</p>
                                    </div>
                                </div>
                            </section>

                            {/* Section 2 */}
                            <section id="cancellation" className="terms-section">
                                <div className="section-badge">02</div>
                                <h2>Cancellation Policy</h2>
                                <div className="section-content">
                                    <div className="policy-grid">
                                        <div className="policy-card">
                                            <span className="days">30+ days</span>
                                            <span className="refund">85% Refund</span>
                                        </div>
                                        <div className="policy-card">
                                            <span className="days">20 days</span>
                                            <span className="refund">75% Refund</span>
                                        </div>
                                        <div className="policy-card">
                                            <span className="days">10 days</span>
                                            <span className="refund">50% Refund</span>
                                        </div>
                                        <div className="policy-card">
                                            <span className="days">Less than 10 days</span>
                                            <span className="refund">No Refund</span>
                                        </div>
                                    </div>
                                    <p className="mt-4">Cancellation requests must be submitted in writing via email to <a href="mailto:cancellations@redgotrips.com">cancellations@redgotrips.com</a>. The refund will be processed within 10-15 business days.</p>
                                </div>
                            </section>

                            {/* Section 3 */}
                            <section id="insurance" className="terms-section">
                                <div className="section-badge">03</div>
                                <h2>Travel Insurance</h2>
                                <div className="section-content">
                                    <p>We strongly recommend purchasing comprehensive travel insurance to cover any unforeseen circumstances, including:</p>
                                    <ul className="insurance-list">
                                        <li><i className="fas fa-check-circle"></i> Trip cancellation or interruption</li>
                                        <li><i className="fas fa-check-circle"></i> Medical emergencies and hospitalization</li>
                                        <li><i className="fas fa-check-circle"></i> Lost, stolen, or damaged luggage</li>
                                        <li><i className="fas fa-check-circle"></i> Flight delays and missed connections</li>
                                        <li><i className="fas fa-check-circle"></i> Emergency evacuation</li>
                                    </ul>
                                    <div className="insurance-cta">
                                        <p>Need travel insurance? We can help you choose the right plan.</p>
                                        <Link to="/contact" className="btn-outline">Contact Us</Link>
                                    </div>
                                </div>
                            </section>

                            {/* Section 4 */}
                            <section id="itinerary" className="terms-section">
                                <div className="section-badge">04</div>
                                <h2>Changes to Itinerary</h2>
                                <div className="section-content">
                                    <p>We reserve the right to modify itineraries due to:</p>
                                    <ul className="itinerary-list">
                                        <li><i className="fas fa-cloud-rain"></i> Weather conditions</li>
                                        <li><i className="fas fa-road"></i> Road closures or landslides</li>
                                        <li><i className="fas fa-ban"></i> Political unrest or strikes</li>
                                        <li><i className="fas fa-hotel"></i> Hotel overbookings</li>
                                        <li><i className="fas fa-clock"></i> Flight delays or cancellations</li>
                                    </ul>
                                    <p>We will make every effort to provide suitable alternatives and notify you as soon as possible.</p>
                                </div>
                            </section>

                            {/* Section 5 */}
                            <section id="liability" className="terms-section">
                                <div className="section-badge">05</div>
                                <h2>Liability</h2>
                                <div className="section-content">
                                    <p>redgotrips acts as an intermediary for hotels, transport providers, and other services. We are not liable for any loss, injury, or damage resulting from the acts or omissions of these third parties.</p>
                                    <p>Our liability is limited to the amount paid for your booking. We are not responsible for:</p>
                                    <ul className="liability-list">
                                        <li><i className="fas fa-times-circle"></i> Personal injury or death</li>
                                        <li><i className="fas fa-times-circle"></i> Loss or damage to belongings</li>
                                        <li><i className="fas fa-times-circle"></i> Delays or schedule changes</li>
                                        <li><i className="fas fa-times-circle"></i> Quality of third-party services</li>
                                    </ul>
                                </div>
                            </section>

                            {/* Section 6 */}
                            <section id="privacy" className="terms-section">
                                <div className="section-badge">06</div>
                                <h2>Privacy Policy</h2>
                                <div className="section-content">
                                    <p>We respect your privacy and are committed to protecting your personal data. Please review our <Link to="/privacy" className="text-link">Privacy Policy</Link> for detailed information on how we collect, use, and protect your information.</p>
                                </div>
                            </section>

                            {/* Section 7 */}
                            <section id="conduct" className="terms-section">
                                <div className="section-badge">07</div>
                                <h2>Guest Conduct</h2>
                                <div className="section-content">
                                    <p>We expect all guests to behave respectfully towards staff, fellow travelers, and local communities. We reserve the right to terminate the booking of any guest who:</p>
                                    <ul className="conduct-list">
                                        <li><i className="fas fa-ban"></i> Engages in illegal activities</li>
                                        <li><i className="fas fa-ban"></i> Causes disturbance to others</li>
                                        <li><i className="fas fa-ban"></i> Damages property</li>
                                        <li><i className="fas fa-ban"></i> Violates local laws or customs</li>
                                    </ul>
                                    <p>No refund will be provided in such cases.</p>
                                </div>
                            </section>

                            {/* Section 8 */}
                            <section id="force" className="terms-section">
                                <div className="section-badge">08</div>
                                <h2>Force Majeure</h2>
                                <div className="section-content">
                                    <p>We shall not be liable for any delay or failure in performance due to circumstances beyond our reasonable control, including but not limited to:</p>
                                    <div className="force-grid">
                                        <span className="force-tag">Natural disasters</span>
                                        <span className="force-tag">Pandemics</span>
                                        <span className="force-tag">War or terrorism</span>
                                        <span className="force-tag">Government actions</span>
                                        <span className="force-tag">Strikes</span>
                                        <span className="force-tag">Power outages</span>
                                    </div>
                                </div>
                            </section>

                            {/* Acceptance */}
                            <div className="terms-acceptance">
                                <p>By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
                            </div>

                            {/* Action Buttons */}
                            <div className="terms-actions">
                                <Link to="/privacy" className="btn-secondary">
                                    <i className="fas fa-shield-alt"></i> Privacy Policy
                                </Link>
                                <Link to="/contact" className="btn-primary">
                                    <i className="fas fa-headset"></i> Contact Support
                                </Link>
                            </div>
                        </div>
                    </main>
                </div>
            </div>

            {/* Custom CSS */}
            <style>{`
                .terms-page {
                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                    min-height: 100vh;
                }

                /* Hero Section */
                .terms-hero {
                    position: relative;
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    padding: 6rem 2rem 2rem;
                    overflow: hidden;
                }

                .hero-pattern {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-image: url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M30 0 L60 30 L30 60 L0 30 Z" fill="rgba(255,255,255,0.03)" /%3E%3C/svg%3E');
                    opacity: 0.5;
                }

                .hero-content {
                    position: relative;
                    max-width: 800px;
                    margin: 0 auto;
                    text-align: center;
                    color: white;
                    z-index: 2;
                }

                .hero-subtitle {
                    display: block;
                    font-size: 1.2rem;
                    text-transform: uppercase;
                    letter-spacing: 3px;
                    margin-bottom: 1rem;
                    opacity: 0.9;
                }

                .hero-title {
                    display: block;
                    font-size: 3.5rem;
                    font-weight: 800;
                    margin-bottom: 1.5rem;
                    text-shadow: 2px 2px 4px rgba(0,0,0,0.2);
                }

                .hero-description {
                    font-size: 1.2rem;
                    max-width: 600px;
                    margin: 0 auto 2rem;
                    opacity: 0.95;
                }

                .last-updated {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.5rem 1.5rem;
                    background: rgba(255,255,255,0.2);
                    backdrop-filter: blur(10px);
                    border-radius: 50px;
                    font-size: 0.9rem;
                    border: 1px solid rgba(255,255,255,0.3);
                }

                .hero-wave {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                }

                .hero-wave svg {
                    width: 100%;
                    height: auto;
                    display: block;
                    fill: #f8fafc;
                }

                /* Container */
                .terms-container {
                    max-width: 1400px;
                    margin: 0 auto;
                    padding: 3rem 2rem;
                }

                /* Grid Layout */
                .terms-grid {
                    display: grid;
                    grid-template-columns: 280px 1fr;
                    gap: 2.5rem;
                }

                /* Sidebar */
                .terms-sidebar {
                    position: relative;
                }

                .sidebar-sticky {
                    position: sticky;
                    top: 100px;
                    background: white;
                    border-radius: 20px;
                    padding: 2rem;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
                }

                .sidebar-sticky h3 {
                    font-size: 1.2rem;
                    color: #1e293b;
                    margin-bottom: 1.5rem;
                    padding-bottom: 0.75rem;
                    border-bottom: 2px solid #f1f5f9;
                }

                .sidebar-nav {
                    list-style: none;
                    padding: 0;
                    margin-bottom: 2rem;
                }

                .sidebar-nav li {
                    margin-bottom: 0.75rem;
                }

                .sidebar-nav a {
                    color: #64748b;
                    text-decoration: none;
                    font-size: 0.95rem;
                    transition: all 0.3s;
                    display: block;
                    padding: 0.5rem 1rem;
                    border-radius: 8px;
                }

                .sidebar-nav a:hover {
                    color: #667eea;
                    background: #f8fafc;
                    transform: translateX(5px);
                }

                .sidebar-contact {
                    text-align: center;
                    padding-top: 1.5rem;
                    border-top: 1px solid #e2e8f0;
                }

                .sidebar-contact p {
                    color: #64748b;
                    margin-bottom: 1rem;
                }

                .contact-phone,
                .contact-email {
                    display: block;
                    color: #1e293b;
                    text-decoration: none;
                    font-size: 0.9rem;
                    margin: 0.5rem 0;
                    transition: color 0.3s;
                }

                .contact-phone i,
                .contact-email i {
                    color: #667eea;
                    margin-right: 0.5rem;
                    width: 20px;
                }

                .contact-phone:hover,
                .contact-email:hover {
                    color: #667eea;
                }

                /* Main Content */
                .terms-main {
                    background: white;
                    border-radius: 30px;
                    box-shadow: 0 20px 40px rgba(0,0,0,0.05);
                    overflow: hidden;
                }

                .terms-content {
                    padding: 3rem;
                }

                /* Introduction */
                .terms-intro {
                    background: #f8fafc;
                    border-radius: 15px;
                    padding: 2rem;
                    margin-bottom: 3rem;
                    border-left: 4px solid #667eea;
                }

                .intro-text {
                    font-size: 1.1rem;
                    line-height: 1.8;
                    color: #1e293b;
                    margin: 0;
                }

                /* Sections */
                .terms-section {
                    margin-bottom: 3rem;
                    padding-bottom: 2rem;
                    border-bottom: 1px solid #e2e8f0;
                    position: relative;
                }

                .terms-section:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }

                .section-badge {
                    position: absolute;
                    top: 0;
                    left: 0;
                    font-size: 5rem;
                    font-weight: 800;
                    color: rgba(102,126,234,0.05);
                    line-height: 1;
                    z-index: 0;
                }

                .terms-section h2 {
                    font-size: 1.8rem;
                    color: #1e293b;
                    margin-bottom: 1.5rem;
                    position: relative;
                    z-index: 1;
                }

                .section-content {
                    position: relative;
                    z-index: 1;
                }

                .section-content p {
                    color: #475569;
                    line-height: 1.8;
                    margin-bottom: 1.5rem;
                }

                /* Lists */
                ul {
                    list-style: none;
                    padding: 0;
                    margin: 1.5rem 0;
                }

                ul li {
                    color: #475569;
                    margin-bottom: 0.75rem;
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                }

                ul li i {
                    color: #667eea;
                    width: 20px;
                }

                /* Payment Methods */
                .payment-methods-list {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 1rem;
                    margin: 1.5rem 0;
                }

                .payment-methods-list li {
                    background: #f8fafc;
                    padding: 1rem;
                    border-radius: 10px;
                    margin: 0;
                }

                .payment-methods-list li i {
                    font-size: 1.5rem;
                    margin-right: 0.5rem;
                }

                /* Policy Grid */
                .policy-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 1rem;
                    margin: 1.5rem 0;
                }

                .policy-card {
                    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
                    padding: 1.5rem;
                    border-radius: 15px;
                    text-align: center;
                    border: 1px solid #e2e8f0;
                }

                .days {
                    display: block;
                    font-size: 1.1rem;
                    font-weight: 600;
                    color: #1e293b;
                    margin-bottom: 0.5rem;
                }

                .refund {
                    display: inline-block;
                    padding: 0.25rem 1rem;
                    background: #667eea;
                    color: white;
                    border-radius: 50px;
                    font-size: 0.9rem;
                    font-weight: 600;
                }

                /* Note Box */
                .note-box {
                    background: #fef9c3;
                    border: 1px solid #fde047;
                    border-radius: 10px;
                    padding: 1.5rem;
                    display: flex;
                    align-items: flex-start;
                    gap: 1rem;
                    margin-top: 1.5rem;
                }

                .note-box i {
                    color: #eab308;
                    font-size: 1.5rem;
                }

                .note-box p {
                    margin: 0;
                    color: #854d0e;
                }

                /* Insurance CTA */
                .insurance-cta {
                    background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
                    border-radius: 10px;
                    padding: 1.5rem;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 1rem;
                    margin-top: 1.5rem;
                }

                .insurance-cta p {
                    margin: 0;
                    color: #1e293b;
                    font-weight: 500;
                }

                .btn-outline {
                    padding: 0.75rem 1.5rem;
                    background: transparent;
                    border: 2px solid #667eea;
                    color: #667eea;
                    border-radius: 8px;
                    text-decoration: none;
                    font-weight: 600;
                    transition: all 0.3s;
                }

                .btn-outline:hover {
                    background: #667eea;
                    color: white;
                }

                /* Force Grid */
                .force-grid {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.75rem;
                    margin: 1.5rem 0;
                }

                .force-tag {
                    padding: 0.5rem 1rem;
                    background: #f1f5f9;
                    border-radius: 50px;
                    font-size: 0.9rem;
                    color: #475569;
                    border: 1px solid #e2e8f0;
                }

                /* Text Link */
                .text-link {
                    color: #667eea;
                    text-decoration: none;
                    font-weight: 600;
                }

                .text-link:hover {
                    text-decoration: underline;
                }

                /* Acceptance */
                .terms-acceptance {
                    background: #f0fdf4;
                    border: 1px solid #86efac;
                    border-radius: 10px;
                    padding: 2rem;
                    text-align: center;
                    margin: 3rem 0 2rem;
                }

                .terms-acceptance p {
                    color: #166534;
                    font-size: 1.1rem;
                    margin: 0;
                }

                /* Action Buttons */
                .terms-actions {
                    display: flex;
                    gap: 1rem;
                    justify-content: center;
                }

                .btn-secondary,
                .btn-primary {
                    padding: 1rem 2rem;
                    border-radius: 10px;
                    text-decoration: none;
                    font-weight: 600;
                    transition: all 0.3s;
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                }

                .btn-secondary {
                    background: #f1f5f9;
                    color: #475569;
                }

                .btn-secondary:hover {
                    background: #e2e8f0;
                    transform: translateY(-2px);
                }

                .btn-primary {
                    background: linear-gradient(135deg, #667eea, #764ba2);
                    color: white;
                }

                .btn-primary:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 10px 25px rgba(102,126,234,0.3);
                }

                /* Back to Home Link */
                .back-home {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                    margin-top: 2rem;
                    color: #64748b;
                    text-decoration: none;
                    font-size: 0.95rem;
                    transition: color 0.3s;
                }

                .back-home:hover {
                    color: #667eea;
                }

                /* Responsive Design */
                @media (max-width: 1024px) {
                    .terms-grid {
                        grid-template-columns: 1fr;
                    }

                    .sidebar-sticky {
                        position: static;
                        margin-bottom: 2rem;
                    }
                }

                @media (max-width: 768px) {
                    .hero-title {
                        font-size: 2.5rem;
                    }

                    .terms-container {
                        padding: 2rem 1rem;
                    }

                    .terms-content {
                        padding: 2rem;
                    }

                    .policy-grid {
                        grid-template-columns: 1fr;
                    }

                    .insurance-cta {
                        flex-direction: column;
                        text-align: center;
                    }

                    .terms-actions {
                        flex-direction: column;
                    }

                    .btn-secondary,
                    .btn-primary {
                        width: 100%;
                        justify-content: center;
                    }
                }

                @media (max-width: 480px) {
                    .hero-title {
                        font-size: 2rem;
                    }

                    .terms-content {
                        padding: 1.5rem;
                    }

                    .section-badge {
                        font-size: 4rem;
                    }

                    .terms-section h2 {
                        font-size: 1.5rem;
                    }

                }

                .hero-content p{
                color:#fff;}
            `}</style>
        </div>
    );
};

export default Terms;
